// Yemini Cafe-compatible RBAC helpers and Bask permission catalog
// - Exports must mirror Yemini Cafe contract

// Bask resources using the exact permission strings from backend
export const PERMISSIONS = {
  USER: {
    CREATE: 'user-create',
    SHOW: 'user-show',
    UPDATE: 'user-update',
    DELETE: 'user-delete',
    LIST: 'user-list',
  },
  CHAT: {
    CREATE: 'chat-create',
    SHOW: 'chat-show',
    UPDATE: 'chat-update',
    DELETE: 'chat-delete',
    LIST: 'chat-list',
  },
  PAYMENT: {
    CREATE: 'payment-create',
    SHOW: 'payment-show',
    UPDATE: 'payment-update',
    DELETE: 'payment-delete',
    LIST: 'payment-list',
  },
  REQUEST: {
    CREATE: 'request-create',
    SHOW: 'request-show',
    UPDATE: 'request-update',
    DELETE: 'request-delete',
    LIST: 'request-list',
  },
  ANALYSIS: {
    VIEW: 'analysis-view',
    EXPORT: 'analysis-export',
    CREATE: 'analysis-create',
  },
  BROKER_PAYMENT: {
    CREATE: 'broker-payment-create',
    SHOW: 'broker-payment-show',
    UPDATE: 'broker-payment-update',
    DELETE: 'broker-payment-delete',
    LIST: 'broker-payment-list',
  },
  ADMIN_BANK_ACCOUNT: {
    CREATE: 'admin-bank-account-create',
    SHOW: 'admin-bank-account-show',
    UPDATE: 'admin-bank-account-update',
    DELETE: 'admin-bank-account-delete',
    LIST: 'admin-bank-account-list',
  },
  BANK_ACCOUNT: {
    CREATE: 'bank-account-create',
    SHOW: 'bank-account-show',
    UPDATE: 'bank-account-update',
    DELETE: 'bank-account-delete',
    LIST: 'bank-account-list',
  },
  BANK: {
    CREATE: 'bank-create',
    SHOW: 'bank-show',
    UPDATE: 'bank-update',
    DELETE: 'bank-delete',
    LIST: 'bank-list',
  },
  CITY: {
    CREATE: 'city-create',
    SHOW: 'city-show',
    UPDATE: 'city-update',
    DELETE: 'city-delete',
    LIST: 'city-list',
  },
  COMPOUND: {
    CREATE: 'compound-create',
    SHOW: 'compound-show',
    UPDATE: 'compound-update',
    DELETE: 'compound-delete',
    LIST: 'compound-list',
  },
  COUNTRY: {
    CREATE: 'country-create',
    SHOW: 'country-show',
    UPDATE: 'country-update',
    DELETE: 'country-delete',
    LIST: 'country-list',
  },
  FEATURE: {
    CREATE: 'feature-create',
    SHOW: 'feature-show',
    UPDATE: 'feature-update',
    DELETE: 'feature-delete',
    LIST: 'feature-list',
  },
  IDENTITY_TYPE: {
    CREATE: 'identity-type-create',
    SHOW: 'identity-type-show',
    UPDATE: 'identity-type-update',
    DELETE: 'identity-type-delete',
    LIST: 'identity-type-list',
  },
  MAINTENANCE_SERVICE: {
    CREATE: 'maintenance-service-create',
    SHOW: 'maintenance-service-show',
    UPDATE: 'maintenance-service-update',
    DELETE: 'maintenance-service-delete',
    LIST: 'maintenance-service-list',
  },
  NOTIFICATION: {
    CREATE: 'notification-create',
    SHOW: 'notification-show',
    UPDATE: 'notification-update',
    DELETE: 'notification-delete',
    LIST: 'notification-list',
  },
  PAYMENT_METHOD: {
    CREATE: 'payment-method-create',
    SHOW: 'payment-method-show',
    UPDATE: 'payment-method-update',
    DELETE: 'payment-method-delete',
    LIST: 'payment-method-list',
  },
  PLACE_TYPE: {
    CREATE: 'place-type-create',
    SHOW: 'place-type-show',
    UPDATE: 'place-type-update',
    DELETE: 'place-type-delete',
    LIST: 'place-type-list',
  },
  PROMO_CODE: {
    CREATE: 'promo-code-create',
    SHOW: 'promo-code-show',
    UPDATE: 'promo-code-update',
    DELETE: 'promo-code-delete',
    LIST: 'promo-code-list',
  },
  SERVICE: {
    CREATE: 'service-create',
    SHOW: 'service-show',
    UPDATE: 'service-update',
    DELETE: 'service-delete',
    LIST: 'service-list',
  },
  SETTING: {
    CREATE: 'setting-create',
    SHOW: 'setting-show',
    UPDATE: 'setting-update',
    DELETE: 'setting-delete',
    LIST: 'setting-list',
  },
  SETTING_TYPE: {
    CREATE: 'setting-type-create',
    SHOW: 'setting-type-show',
    UPDATE: 'setting-type-update',
    DELETE: 'setting-type-delete',
    LIST: 'setting-type-list',
  },
  SOCIAL_MEDIA: {
    CREATE: 'social-media-create',
    SHOW: 'social-media-show',
    UPDATE: 'social-media-update',
    DELETE: 'social-media-delete',
    LIST: 'social-media-list',
  },
  UNIT_TYPE: {
    CREATE: 'unit-type-create',
    SHOW: 'unit-type-show',
    UPDATE: 'unit-type-update',
    DELETE: 'unit-type-delete',
    LIST: 'unit-type-list',
  },
  BOOKING: {
    CREATE: 'booking-create',
    SHOW: 'booking-show',
    UPDATE: 'booking-update',
    DELETE: 'booking-delete',
    LIST: 'booking-list',
  },
  BROKER: {
    CREATE: 'broker-create',
    SHOW: 'broker-show',
    UPDATE: 'broker-update',
    DELETE: 'broker-delete',
    LIST: 'broker-list',
  },
  CANCELLATION_REQUEST: {
    CREATE: 'cancellation-request-create',
    SHOW: 'cancellation-request-show',
    UPDATE: 'cancellation-request-update',
    DELETE: 'cancellation-request-delete',
    LIST: 'cancellation-request-list',
  },
  CLIENT: {
    CREATE: 'client-create',
    SHOW: 'client-show',
    UPDATE: 'client-update',
    DELETE: 'client-delete',
    LIST: 'client-list',
  },
  CONTACT_US: {
    CREATE: 'contact-us-create',
    SHOW: 'contact-us-show',
    UPDATE: 'contact-us-update',
    DELETE: 'contact-us-delete',
    LIST: 'contact-us-list',
  },
  CONTRACT: {
    CREATE: 'contract-create',
    SHOW: 'contract-show',
    UPDATE: 'contract-update',
    DELETE: 'contract-delete',
    LIST: 'contract-list',
  },
  MAINTENANCE: {
    CREATE: 'maintenace-create',
    SHOW: 'maintenace-show',
    UPDATE: 'maintenace-update',
    DELETE: 'maintenace-delete',
    LIST: 'maintenace-list',
  },
  OWNER: {
    CREATE: 'owner-create',
    SHOW: 'owner-show',
    UPDATE: 'owner-update',
    DELETE: 'owner-delete',
    LIST: 'owner-list',
  },
  REFUND_REQUEST: {
    CREATE: 'refund-request-create',
    SHOW: 'refund-request-show',
    UPDATE: 'refund-request-update',
    DELETE: 'refund-request-delete',
    LIST: 'refund-request-list',
  },
  ROLE: {
    CREATE: 'role-create',
    SHOW: 'role-show',
    UPDATE: 'role-update',
    DELETE: 'role-delete',
    LIST: 'role-list',
  },
  PERMISSION: {
    CREATE: 'permission-create',
    SHOW: 'permission-show',
    UPDATE: 'permission-update',
    DELETE: 'permission-delete',
    LIST: 'permission-list',
  },
  SERVICE_REQUEST: {
    CREATE: 'service-request-create',
    SHOW: 'service-request-show',
    UPDATE: 'service-request-update',
    DELETE: 'service-request-delete',
    LIST: 'service-request-list',
  },
  UNIT: {
    CREATE: 'unit-create',
    SHOW: 'unit-show',
    UPDATE: 'unit-update',
    DELETE: 'unit-delete',
    LIST: 'unit-list',
  },
  UNIT_PRICE: {
    CREATE: 'unit-price-create',
    SHOW: 'unit-price-show',
    UPDATE: 'unit-price-update',
    DELETE: 'unit-price-delete',
    LIST: 'unit-price-list',
  },
};

// Permission groups following Yemini Cafe pattern
export const PERMISSION_GROUPS_LEGACY = {
  ADMIN: Object.values(PERMISSIONS).flatMap(group => Object.values(group)),
  EDITOR: [
    // Non-destructive actions across major resources
    PERMISSIONS.CLIENT.SHOW,
    PERMISSIONS.CLIENT.LIST,
    PERMISSIONS.CLIENT.CREATE,
    PERMISSIONS.CLIENT.UPDATE,

    PERMISSIONS.UNIT.SHOW,
    PERMISSIONS.UNIT.LIST,
    PERMISSIONS.UNIT.CREATE,
    PERMISSIONS.UNIT.UPDATE,

    PERMISSIONS.BOOKING.SHOW,
    PERMISSIONS.BOOKING.LIST,
    PERMISSIONS.BOOKING.CREATE,
    PERMISSIONS.BOOKING.UPDATE,

    PERMISSIONS.FEATURE.SHOW,
    PERMISSIONS.FEATURE.LIST,
    PERMISSIONS.FEATURE.CREATE,
    PERMISSIONS.FEATURE.UPDATE,

    PERMISSIONS.SERVICE.SHOW,
    PERMISSIONS.SERVICE.LIST,
    PERMISSIONS.SERVICE.CREATE,
    PERMISSIONS.SERVICE.UPDATE,

    PERMISSIONS.MAINTENANCE.SHOW,
    PERMISSIONS.MAINTENANCE.LIST,
    PERMISSIONS.MAINTENANCE.CREATE,
    PERMISSIONS.MAINTENANCE.UPDATE,

    PERMISSIONS.SETTING.SHOW,
    PERMISSIONS.SETTING.LIST,
    PERMISSIONS.SETTING.UPDATE,
  ],
  VIEWER: [
    PERMISSIONS.CLIENT.SHOW,
    PERMISSIONS.CLIENT.LIST,
    PERMISSIONS.UNIT.SHOW,
    PERMISSIONS.UNIT.LIST,
    PERMISSIONS.BOOKING.SHOW,
    PERMISSIONS.BOOKING.LIST,
    PERMISSIONS.FEATURE.SHOW,
    PERMISSIONS.FEATURE.LIST,
    PERMISSIONS.SERVICE.SHOW,
    PERMISSIONS.SERVICE.LIST,
    PERMISSIONS.MAINTENANCE.SHOW,
    PERMISSIONS.MAINTENANCE.LIST,
    PERMISSIONS.SETTING.SHOW,
    PERMISSIONS.SETTING.LIST,
  ],
};

// Human-readable descriptions matching exact permission strings
export const PERMISSION_DESCRIPTIONS = {
  // Admin Bank Account
  'admin-bank-account-create': 'Create admin bank accounts',
  'admin-bank-account-show': 'View admin bank account details',
  'admin-bank-account-update': 'Edit admin bank accounts',
  'admin-bank-account-delete': 'Delete admin bank accounts',
  'admin-bank-account-list': 'View list of admin bank accounts',

  // Bank Account
  'bank-account-create': 'Create bank accounts',
  'bank-account-show': 'View bank account details',
  'bank-account-update': 'Edit bank accounts',
  'bank-account-delete': 'Delete bank accounts',
  'bank-account-list': 'View list of bank accounts',

  // Bank
  'bank-create': 'Create banks',
  'bank-show': 'View bank details',
  'bank-update': 'Edit banks',
  'bank-delete': 'Delete banks',
  'bank-list': 'View list of banks',

  // City
  'city-create': 'Create cities',
  'city-show': 'View city details',
  'city-update': 'Edit cities',
  'city-delete': 'Delete cities',
  'city-list': 'View list of cities',

  // Compound
  'compound-create': 'Create compounds',
  'compound-show': 'View compound details',
  'compound-update': 'Edit compounds',
  'compound-delete': 'Delete compounds',
  'compound-list': 'View list of compounds',

  // Country
  'country-create': 'Create countries',
  'country-show': 'View country details',
  'country-update': 'Edit countries',
  'country-delete': 'Delete countries',
  'country-list': 'View list of countries',

  // Feature
  'feature-create': 'Create features',
  'feature-show': 'View feature details',
  'feature-update': 'Edit features',
  'feature-delete': 'Delete features',
  'feature-list': 'View list of features',

  // Identity Type
  'identity-type-create': 'Create identity types',
  'identity-type-show': 'View identity type details',
  'identity-type-update': 'Edit identity types',
  'identity-type-delete': 'Delete identity types',
  'identity-type-list': 'View list of identity types',

  // Maintenance Service
  'maintenance-service-create': 'Create maintenance services',
  'maintenance-service-show': 'View maintenance service details',
  'maintenance-service-update': 'Edit maintenance services',
  'maintenance-service-delete': 'Delete maintenance services',
  'maintenance-service-list': 'View list of maintenance services',

  // Notification
  'notification-create': 'Create notifications',
  'notification-show': 'View notification details',
  'notification-update': 'Edit notifications',
  'notification-delete': 'Delete notifications',
  'notification-list': 'View list of notifications',

  // Payment Method
  'payment-method-create': 'Create payment methods',
  'payment-method-show': 'View payment method details',
  'payment-method-update': 'Edit payment methods',
  'payment-method-delete': 'Delete payment methods',
  'payment-method-list': 'View list of payment methods',

  // Place Type
  'place-type-create': 'Create place types',
  'place-type-show': 'View place type details',
  'place-type-update': 'Edit place types',
  'place-type-delete': 'Delete place types',
  'place-type-list': 'View list of place types',

  // Promo Code
  'promo-code-create': 'Create promo codes',
  'promo-code-show': 'View promo code details',
  'promo-code-update': 'Edit promo codes',
  'promo-code-delete': 'Delete promo codes',
  'promo-code-list': 'View list of promo codes',

  // Service
  'service-create': 'Create services',
  'service-show': 'View service details',
  'service-update': 'Edit services',
  'service-delete': 'Delete services',
  'service-list': 'View list of services',

  // Setting
  'setting-create': 'Create settings',
  'setting-show': 'View setting details',
  'setting-update': 'Edit settings',
  'setting-delete': 'Delete settings',
  'setting-list': 'View list of settings',

  // Setting Type
  'setting-type-create': 'Create setting types',
  'setting-type-show': 'View setting type details',
  'setting-type-update': 'Edit setting types',
  'setting-type-delete': 'Delete setting types',
  'setting-type-list': 'View list of setting types',

  // Social Media
  'social-media-create': 'Create social media entries',
  'social-media-show': 'View social media details',
  'social-media-update': 'Edit social media entries',
  'social-media-delete': 'Delete social media entries',
  'social-media-list': 'View list of social media entries',

  // Unit Type
  'unit-type-create': 'Create unit types',
  'unit-type-show': 'View unit type details',
  'unit-type-update': 'Edit unit types',
  'unit-type-delete': 'Delete unit types',
  'unit-type-list': 'View list of unit types',

  // Booking
  'booking-create': 'Create bookings',
  'booking-show': 'View booking details',
  'booking-update': 'Edit bookings',
  'booking-delete': 'Delete bookings',
  'booking-list': 'View list of bookings',

  // Broker
  'broker-create': 'Create brokers',
  'broker-show': 'View broker details',
  'broker-update': 'Edit brokers',
  'broker-delete': 'Delete brokers',
  'broker-list': 'View list of brokers',

  // Cancellation Request
  'cancellation-request-create': 'Create cancellation requests',
  'cancellation-request-show': 'View cancellation request details',
  'cancellation-request-update': 'Edit cancellation requests',
  'cancellation-request-delete': 'Delete cancellation requests',
  'cancellation-request-list': 'View list of cancellation requests',

  // Client
  'client-create': 'Create clients',
  'client-show': 'View client details',
  'client-update': 'Edit clients',
  'client-delete': 'Delete clients',
  'client-list': 'View list of clients',

  // Contact Us
  'contact-us-create': 'Create contact us entries',
  'contact-us-show': 'View contact us details',
  'contact-us-update': 'Edit contact us entries',
  'contact-us-delete': 'Delete contact us entries',
  'contact-us-list': 'View list of contact us entries',

  // Contract
  'contract-create': 'Create contracts',
  'contract-show': 'View contract details',
  'contract-update': 'Edit contracts',
  'contract-delete': 'Delete contracts',
  'contract-list': 'View list of contracts',

  // Maintenance
  'maintenace-create': 'Create maintenance records',
  'maintenace-show': 'View maintenance details',
  'maintenace-update': 'Edit maintenance records',
  'maintenace-delete': 'Delete maintenance records',
  'maintenace-list': 'View list of maintenance records',

  // Owner
  'owner-create': 'Create owners',
  'owner-show': 'View owner details',
  'owner-update': 'Edit owners',
  'owner-delete': 'Delete owners',
  'owner-list': 'View list of owners',

  // Refund Request
  'refund-request-create': 'Create refund requests',
  'refund-request-show': 'View refund request details',
  'refund-request-update': 'Edit refund requests',
  'refund-request-delete': 'Delete refund requests',
  'refund-request-list': 'View list of refund requests',

  // Role
  'role-create': 'Create new roles',
  'role-show': 'View role details',
  'role-update': 'Edit existing roles',
  'role-delete': 'Delete roles',
  'role-list': 'View list of roles',

  // Permission
  'permission-create': 'Create new permissions',
  'permission-show': 'View permission details',
  'permission-update': 'Edit existing permissions',
  'permission-delete': 'Delete permissions',
  'permission-list': 'View list of permissions',

  // Service Request
  'service-request-create': 'Create service requests',
  'service-request-show': 'View service request details',
  'service-request-update': 'Edit service requests',
  'service-request-delete': 'Delete service requests',
  'service-request-list': 'View list of service requests',

  // Unit
  'unit-create': 'Create units',
  'unit-show': 'View unit details',
  'unit-update': 'Edit units',
  'unit-delete': 'Delete units',
  'unit-list': 'View list of units',

  // Unit Price
  'unit-price-create': 'Create unit prices',
  'unit-price-show': 'View unit price details',
  'unit-price-update': 'Edit unit prices',
  'unit-price-delete': 'Delete unit prices',
  'unit-price-list': 'View list of unit prices',
};

// Helper function semantics (copy EXACTLY from Yemini Cafe)
export const hasPermission = (userPermissions, requiredPermissions) => {
  if (!userPermissions || !Array.isArray(userPermissions)) return false;
  if (Array.isArray(requiredPermissions)) {
    return requiredPermissions.some(permission => userPermissions.includes(permission));
  }
  return userPermissions.includes(requiredPermissions);
};

export const hasAllPermissions = (userPermissions, requiredPermissions) => {
  if (!userPermissions || !Array.isArray(userPermissions)) return false;
  return requiredPermissions.every(permission => userPermissions.includes(permission));
};

export const getMissingPermissions = (userPermissions, requiredPermissions) => {
  if (!userPermissions || !Array.isArray(userPermissions)) return requiredPermissions;
  return requiredPermissions.filter(permission => !userPermissions.includes(permission));
};

// Permission Groups for Accordion UI
export const PERMISSION_GROUPS = {
  PROPERTY_MANAGEMENT: {
    id: 'property-management',
    name: 'Property Management',
    description: 'Complete unit and property management capabilities',
    icon: '🏠',
    corePermissions: [
      PERMISSIONS.UNIT.CREATE,
      PERMISSIONS.UNIT.UPDATE,
      PERMISSIONS.UNIT.SHOW,
      PERMISSIONS.UNIT.LIST,
      PERMISSIONS.UNIT.DELETE,
    ],
    relatedPermissions: [
      PERMISSIONS.OWNER.CREATE,
      PERMISSIONS.OWNER.UPDATE,
      PERMISSIONS.OWNER.SHOW,
      PERMISSIONS.OWNER.LIST,
      PERMISSIONS.OWNER.DELETE,
      PERMISSIONS.COMPOUND.CREATE,
      PERMISSIONS.COMPOUND.UPDATE,
      PERMISSIONS.COMPOUND.SHOW,
      PERMISSIONS.COMPOUND.LIST,
      PERMISSIONS.COMPOUND.DELETE,
      PERMISSIONS.FEATURE.CREATE,
      PERMISSIONS.FEATURE.UPDATE,
      PERMISSIONS.FEATURE.SHOW,
      PERMISSIONS.FEATURE.LIST,
      PERMISSIONS.FEATURE.DELETE,
      PERMISSIONS.UNIT_TYPE.CREATE,
      PERMISSIONS.UNIT_TYPE.UPDATE,
      PERMISSIONS.UNIT_TYPE.SHOW,
      PERMISSIONS.UNIT_TYPE.LIST,
      PERMISSIONS.UNIT_TYPE.DELETE,
      PERMISSIONS.PLACE_TYPE.CREATE,
      PERMISSIONS.PLACE_TYPE.UPDATE,
      PERMISSIONS.PLACE_TYPE.SHOW,
      PERMISSIONS.PLACE_TYPE.LIST,
      PERMISSIONS.PLACE_TYPE.DELETE,
      PERMISSIONS.BROKER.CREATE,
      PERMISSIONS.BROKER.UPDATE,
      PERMISSIONS.BROKER.SHOW,
      PERMISSIONS.BROKER.LIST,
      PERMISSIONS.BROKER.DELETE,
      PERMISSIONS.UNIT_PRICE.CREATE,
      PERMISSIONS.UNIT_PRICE.UPDATE,
      PERMISSIONS.UNIT_PRICE.SHOW,
      PERMISSIONS.UNIT_PRICE.LIST,
      PERMISSIONS.UNIT_PRICE.DELETE,
    ],
    businessLogic: 'To manage units, you need access to owners, compounds, features, and pricing',
    dependencies: {
      [PERMISSIONS.UNIT.CREATE]: [PERMISSIONS.OWNER.LIST, PERMISSIONS.COMPOUND.LIST, PERMISSIONS.FEATURE.LIST, PERMISSIONS.UNIT_TYPE.LIST],
      [PERMISSIONS.UNIT.UPDATE]: [PERMISSIONS.OWNER.LIST, PERMISSIONS.COMPOUND.LIST, PERMISSIONS.FEATURE.LIST, PERMISSIONS.UNIT_TYPE.LIST],
    }
  },
  BOOKING_MANAGEMENT: {
    id: 'booking-management',
    name: 'Booking & Reservation Management',
    description: 'Complete booking and reservation system',
    icon: '📅',
    corePermissions: [
      PERMISSIONS.BOOKING.CREATE,
      PERMISSIONS.BOOKING.UPDATE,
      PERMISSIONS.BOOKING.SHOW,
      PERMISSIONS.BOOKING.LIST,
      PERMISSIONS.BOOKING.DELETE,
    ],
    relatedPermissions: [
      PERMISSIONS.UNIT.SHOW,
      PERMISSIONS.UNIT.LIST,
      PERMISSIONS.CLIENT.CREATE,
      PERMISSIONS.CLIENT.UPDATE,
      PERMISSIONS.CLIENT.SHOW,
      PERMISSIONS.CLIENT.LIST,
      PERMISSIONS.CLIENT.DELETE,
      PERMISSIONS.PAYMENT.CREATE,
      PERMISSIONS.PAYMENT.UPDATE,
      PERMISSIONS.PAYMENT.SHOW,
      PERMISSIONS.PAYMENT.LIST,
      PERMISSIONS.PAYMENT.DELETE,
      PERMISSIONS.CANCELLATION_REQUEST.CREATE,
      PERMISSIONS.CANCELLATION_REQUEST.UPDATE,
      PERMISSIONS.CANCELLATION_REQUEST.SHOW,
      PERMISSIONS.CANCELLATION_REQUEST.LIST,
      PERMISSIONS.CANCELLATION_REQUEST.DELETE,
      PERMISSIONS.REFUND_REQUEST.CREATE,
      PERMISSIONS.REFUND_REQUEST.UPDATE,
      PERMISSIONS.REFUND_REQUEST.SHOW,
      PERMISSIONS.REFUND_REQUEST.LIST,
      PERMISSIONS.REFUND_REQUEST.DELETE,
    ],
    businessLogic: 'To manage bookings, you need access to units, clients, and payment systems',
    dependencies: {
      [PERMISSIONS.BOOKING.CREATE]: [PERMISSIONS.UNIT.LIST, PERMISSIONS.CLIENT.LIST],
      [PERMISSIONS.BOOKING.UPDATE]: [PERMISSIONS.UNIT.LIST, PERMISSIONS.CLIENT.LIST],
    }
  },
  FINANCIAL_MANAGEMENT: {
    id: 'financial-management',
    name: 'Owner & Financial Management',
    description: 'Owner management and financial operations',
    icon: '💰',
    corePermissions: [
      PERMISSIONS.OWNER.CREATE,
      PERMISSIONS.OWNER.UPDATE,
      PERMISSIONS.OWNER.SHOW,
      PERMISSIONS.OWNER.LIST,
      PERMISSIONS.OWNER.DELETE,
      PERMISSIONS.PAYMENT.CREATE,
      PERMISSIONS.PAYMENT.UPDATE,
      PERMISSIONS.PAYMENT.SHOW,
      PERMISSIONS.PAYMENT.LIST,
      PERMISSIONS.PAYMENT.DELETE,
      PERMISSIONS.BROKER_PAYMENT.CREATE,
      PERMISSIONS.BROKER_PAYMENT.UPDATE,
      PERMISSIONS.BROKER_PAYMENT.SHOW,
      PERMISSIONS.BROKER_PAYMENT.LIST,
      PERMISSIONS.BROKER_PAYMENT.DELETE,
    ],
    relatedPermissions: [
      PERMISSIONS.BANK.CREATE,
      PERMISSIONS.BANK.UPDATE,
      PERMISSIONS.BANK.SHOW,
      PERMISSIONS.BANK.LIST,
      PERMISSIONS.BANK.DELETE,
      PERMISSIONS.BANK_ACCOUNT.CREATE,
      PERMISSIONS.BANK_ACCOUNT.UPDATE,
      PERMISSIONS.BANK_ACCOUNT.SHOW,
      PERMISSIONS.BANK_ACCOUNT.LIST,
      PERMISSIONS.BANK_ACCOUNT.DELETE,
      PERMISSIONS.REFUND_REQUEST.CREATE,
      PERMISSIONS.REFUND_REQUEST.UPDATE,
      PERMISSIONS.REFUND_REQUEST.SHOW,
      PERMISSIONS.REFUND_REQUEST.LIST,
      PERMISSIONS.REFUND_REQUEST.DELETE,
    ],
    businessLogic: 'To manage owners and payments, you need access to banking and refund systems',
    dependencies: {
      [PERMISSIONS.OWNER.CREATE]: [PERMISSIONS.BANK.LIST, PERMISSIONS.BANK_ACCOUNT.LIST],
      [PERMISSIONS.PAYMENT.CREATE]: [PERMISSIONS.BANK.LIST, PERMISSIONS.BANK_ACCOUNT.LIST],
    }
  },
  SYSTEM_ADMINISTRATION: {
    id: 'system-administration',
    name: 'System Administration',
    description: 'System settings and configuration',
    icon: '⚙️',
    corePermissions: [
      PERMISSIONS.SETTING.CREATE,
      PERMISSIONS.SETTING.UPDATE,
      PERMISSIONS.SETTING.SHOW,
      PERMISSIONS.SETTING.LIST,
      PERMISSIONS.SETTING.DELETE,
      PERMISSIONS.SETTING_TYPE.CREATE,
      PERMISSIONS.SETTING_TYPE.UPDATE,
      PERMISSIONS.SETTING_TYPE.SHOW,
      PERMISSIONS.SETTING_TYPE.LIST,
      PERMISSIONS.SETTING_TYPE.DELETE,
    ],
    relatedPermissions: [
      PERMISSIONS.COUNTRY.CREATE,
      PERMISSIONS.COUNTRY.UPDATE,
      PERMISSIONS.COUNTRY.SHOW,
      PERMISSIONS.COUNTRY.LIST,
      PERMISSIONS.COUNTRY.DELETE,
      PERMISSIONS.CITY.CREATE,
      PERMISSIONS.CITY.UPDATE,
      PERMISSIONS.CITY.SHOW,
      PERMISSIONS.CITY.LIST,
      PERMISSIONS.CITY.DELETE,
      PERMISSIONS.IDENTITY_TYPE.CREATE,
      PERMISSIONS.IDENTITY_TYPE.UPDATE,
      PERMISSIONS.IDENTITY_TYPE.SHOW,
      PERMISSIONS.IDENTITY_TYPE.LIST,
      PERMISSIONS.IDENTITY_TYPE.DELETE,
      PERMISSIONS.PAYMENT_METHOD.CREATE,
      PERMISSIONS.PAYMENT_METHOD.UPDATE,
      PERMISSIONS.PAYMENT_METHOD.SHOW,
      PERMISSIONS.PAYMENT_METHOD.LIST,
      PERMISSIONS.PAYMENT_METHOD.DELETE,
      PERMISSIONS.PROMO_CODE.CREATE,
      PERMISSIONS.PROMO_CODE.UPDATE,
      PERMISSIONS.PROMO_CODE.SHOW,
      PERMISSIONS.PROMO_CODE.LIST,
      PERMISSIONS.PROMO_CODE.DELETE,
      PERMISSIONS.SOCIAL_MEDIA.CREATE,
      PERMISSIONS.SOCIAL_MEDIA.UPDATE,
      PERMISSIONS.SOCIAL_MEDIA.SHOW,
      PERMISSIONS.SOCIAL_MEDIA.LIST,
      PERMISSIONS.SOCIAL_MEDIA.DELETE,
    ],
    businessLogic: 'To configure the system, you need access to all reference data and settings',
    dependencies: {}
  },
  CONTENT_MANAGEMENT: {
    id: 'content-management',
    name: 'Content & Service Management',
    description: 'Website content and service management',
    icon: '📝',
    corePermissions: [
      PERMISSIONS.FEATURE.CREATE,
      PERMISSIONS.FEATURE.UPDATE,
      PERMISSIONS.FEATURE.SHOW,
      PERMISSIONS.FEATURE.LIST,
      PERMISSIONS.FEATURE.DELETE,
      PERMISSIONS.SERVICE.CREATE,
      PERMISSIONS.SERVICE.UPDATE,
      PERMISSIONS.SERVICE.SHOW,
      PERMISSIONS.SERVICE.LIST,
      PERMISSIONS.SERVICE.DELETE,
      PERMISSIONS.MAINTENANCE_SERVICE.CREATE,
      PERMISSIONS.MAINTENANCE_SERVICE.UPDATE,
      PERMISSIONS.MAINTENANCE_SERVICE.SHOW,
      PERMISSIONS.MAINTENANCE_SERVICE.LIST,
      PERMISSIONS.MAINTENANCE_SERVICE.DELETE,
    ],
    relatedPermissions: [
      PERMISSIONS.NOTIFICATION.CREATE,
      PERMISSIONS.NOTIFICATION.UPDATE,
      PERMISSIONS.NOTIFICATION.SHOW,
      PERMISSIONS.NOTIFICATION.LIST,
      PERMISSIONS.NOTIFICATION.DELETE,
      PERMISSIONS.CONTACT_US.CREATE,
      PERMISSIONS.CONTACT_US.UPDATE,
      PERMISSIONS.CONTACT_US.SHOW,
      PERMISSIONS.CONTACT_US.LIST,
      PERMISSIONS.CONTACT_US.DELETE,
    ],
    businessLogic: 'To manage content and services, you need access to notifications and contact management',
    dependencies: {}
  },
  USER_MANAGEMENT: {
    id: 'user-management',
    name: 'User & Access Control',
    description: 'User management and access control',
    icon: '👥',
    corePermissions: [
      PERMISSIONS.USER.CREATE,
      PERMISSIONS.USER.UPDATE,
      PERMISSIONS.USER.SHOW,
      PERMISSIONS.USER.LIST,
      PERMISSIONS.USER.DELETE,
      PERMISSIONS.CLIENT.CREATE,
      PERMISSIONS.CLIENT.UPDATE,
      PERMISSIONS.CLIENT.SHOW,
      PERMISSIONS.CLIENT.LIST,
      PERMISSIONS.CLIENT.DELETE,
      PERMISSIONS.ROLE.CREATE,
      PERMISSIONS.ROLE.UPDATE,
      PERMISSIONS.ROLE.SHOW,
      PERMISSIONS.ROLE.LIST,
      PERMISSIONS.ROLE.DELETE,
      PERMISSIONS.PERMISSION.CREATE,
      PERMISSIONS.PERMISSION.UPDATE,
      PERMISSIONS.PERMISSION.SHOW,
      PERMISSIONS.PERMISSION.LIST,
      PERMISSIONS.PERMISSION.DELETE,
    ],
    relatedPermissions: [],
    businessLogic: 'User management is independent of other business operations',
    dependencies: {}
  },
  COMMUNICATION: {
    id: 'communication',
    name: 'Communication & Support',
    description: 'Communication and customer support',
    icon: '💬',
    corePermissions: [
      PERMISSIONS.CHAT.CREATE,
      PERMISSIONS.CHAT.UPDATE,
      PERMISSIONS.CHAT.SHOW,
      PERMISSIONS.CHAT.LIST,
      PERMISSIONS.CHAT.DELETE,
      PERMISSIONS.NOTIFICATION.CREATE,
      PERMISSIONS.NOTIFICATION.UPDATE,
      PERMISSIONS.NOTIFICATION.SHOW,
      PERMISSIONS.NOTIFICATION.LIST,
      PERMISSIONS.NOTIFICATION.DELETE,
      PERMISSIONS.CONTACT_US.CREATE,
      PERMISSIONS.CONTACT_US.UPDATE,
      PERMISSIONS.CONTACT_US.SHOW,
      PERMISSIONS.CONTACT_US.LIST,
      PERMISSIONS.CONTACT_US.DELETE,
    ],
    relatedPermissions: [
      PERMISSIONS.CLIENT.SHOW,
      PERMISSIONS.CLIENT.LIST,
    ],
    businessLogic: 'To provide support, you need access to communication tools and customer data',
    dependencies: {}
  },
  ANALYSIS: {
    id: 'analysis',
    name: 'Analysis & Reporting',
    description: 'Analytics and reporting capabilities',
    icon: '📊',
    corePermissions: [
      PERMISSIONS.ANALYSIS.VIEW,
      PERMISSIONS.ANALYSIS.EXPORT,
      PERMISSIONS.ANALYSIS.CREATE,
    ],
    relatedPermissions: [
      PERMISSIONS.UNIT.SHOW,
      PERMISSIONS.UNIT.LIST,
      PERMISSIONS.BOOKING.SHOW,
      PERMISSIONS.BOOKING.LIST,
      PERMISSIONS.PAYMENT.SHOW,
      PERMISSIONS.PAYMENT.LIST,
    ],
    businessLogic: 'To generate reports, you need read access to relevant business data',
    dependencies: {}
  }
};

// Helper function to get all permissions from a group
export const getGroupPermissions = (groupId) => {
  const group = PERMISSION_GROUPS[groupId];
  if (!group) return [];
  return [...group.corePermissions, ...group.relatedPermissions];
};

// Helper function to get permission dependencies
export const getPermissionDependencies = (permission) => {
  for (const group of Object.values(PERMISSION_GROUPS)) {
    if (group.dependencies[permission]) {
      return group.dependencies[permission];
    }
  }
  return [];
};

// Helper function to check if permission is core or related
export const isCorePermission = (permission, groupId) => {
  const group = PERMISSION_GROUPS[groupId];
  return group ? group.corePermissions.includes(permission) : false;
};

export default PERMISSIONS;


